const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const WORKOUT_INSTRUCTIONS = new Set([
  'do_workout_generated_manually',
  'do_workout_generated_automatically_in_advance',
  'do_workout_regenerated_every_time',
]);

function dateOnly(dateValue) {
  const value = String(dateValue || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null;
}

function dateOnlyWeekday(dateValue) {
  const value = dateOnly(dateValue);
  if (!value) return null;
  return WEEKDAYS[new Date(`${value}T12:00:00`).getDay()];
}

function isEntryScheduledOnDate(entry, now = new Date()) {
  if (!WORKOUT_INSTRUCTIONS.has(entry?.instruction)) return false;
  const start = dateOnly(entry.start_time);
  if (!start) return false;
  const today = new Date(now);
  const todayDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  if (todayDate < start) return false;

  const unit = String(entry.recurrence_unit || '').toLowerCase();
  if (unit === 'days') return true;
  if (unit === 'weeks') return dateOnlyWeekday(start) === WEEKDAYS[today.getDay()];
  if (unit === 'months') return Number(start.slice(8, 10)) === today.getDate();
  return todayDate === start;
}

export function getCanonicalWorkoutForToday(entries = [], now = new Date()) {
  return entries.find(entry => isEntryScheduledOnDate(entry, now)) || null;
}

export function getCanonicalWorkoutWeekday(entries = [], entry) {
  return entry ? dateOnlyWeekday(entry.start_time) : null;
}
